// extracted by mini-css-extract-plugin
module.exports = {"productImageContainer":"ProductImageContainer_productImageContainer__40bzc","featured":"ProductImageContainer_featured__5M284"};